import { deleteRequest } from '@/core';
import { packageTypes } from '@/requests';
export default async function deletePackageTypeRequest(idToDelete) {
	let url = packageTypes.getByIdPath(idToDelete);
	return deleteRequest(url);
}